document.addEventListener('DOMContentLoaded', function () {
    devtricker_attachArgon2OnLoad();
});

function devtricker_attachArgon2OnLoad() {
    
    const modalElements = document.getElementsByClassName("load-argon");

    if (modalElements.length > 0) {

        if (typeof window.argon2Loaded === 'undefined' || !window.argon2Loaded) {
            loadScript(g_devtricker_Settings.themeUrl + '/dist/js/argon2-bundled.min.js', function () {
                window.argon2Loaded = true;
                console.log('argon2 loaded!');
            });
        }
    }
}